// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bookappointment_wrapper__1ZwLG","container":"bookappointment_container__33gBt","items":"bookappointment_items__2y_EC","item":"bookappointment_item__35KjT"};